import type { ElementType, HTMLAttributes } from "react"

import { tv, type VariantProps } from "@/lib/utils/tv"

const heading = tv({
  variants: {
    variant: {
      heroSplit: "text-hero-split",
      sectionCardTitle: "text-section-card-title",
      lookTitle: "text-look-title",
      displayHero: "text-display-hero",
      display2xl: "text-display-2xl",
      displayLg: "text-display-lg",
      displaySm: "text-display-sm",
      section: "text-section",
      sectionHead: "text-section-head",
      productTitle: "text-product-title",
      xl: "text-heading-xl",
      lg: "text-heading-lg",
      md: "text-heading-md",
      sm: "text-heading-sm",
      flowMd: "text-flow-md-semibold",
      referral: "text-referral-title",
      referralWide: "text-referral-title md:text-referral-title-wide",
      referralPage: "text-referral-title md:text-referral-title-wide lg:text-referral-title-desktop",
    },
    family: {
      text: "font-text",
      display: "font-display",
      hero: "font-hero",
      mono: "font-mono",
    },
    tone: {
      default: "text-fg",
      strong: "text-fg-strong",
      muted: "text-fg-muted",
      faint: "text-fg-faint",
      inverted: "text-fg-inverted",
      brand: "text-fg-brand",
      promise: "text-fg-promise",
      receipt: "text-fg-receipt",
      inherit: "",
    },
    numeric: { true: "tabular-nums" },
    balance: { true: "text-balance" },
  },
  defaultVariants: { variant: "md", family: "display", tone: "default" },
})

export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof heading> {
  as?: ElementType
}

export const Heading = ({ as: Component = "h2", variant, family, tone, numeric, balance, className, ...rest }: HeadingProps) => (
  <Component className={heading({ variant, family, tone, numeric, balance, className })} {...rest} />
)
